import { Component, Input, OnInit, EventEmitter, Output, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { constants } from '../../utitlity/constant';
// import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';
declare const Webcam: any;
@Component({
    selector: 'ntb-camera',
    template: require('./camera.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CameraComponent implements OnInit, OnDestroy {
    
    @ViewChild('cameraEle') cameraEle: ElementRef
    @Output() snapEvent: EventEmitter<string> = new EventEmitter<string>();
   
    constructor() { }
    ngOnInit() {
    }


    takeSnap(){
        Webcam.snap((uri)=>{
            this.snapEvent.emit(uri);
        })
    }

    loadCamera(){
        Webcam.set({
            width: 310,
            height: 200,
            image_format: 'jpeg',
            jpeg_quality: 90,
    
          });
        Webcam.setSWFLocation('/content/dam/hsbc/ae/menaetb/images/webcam.swf');
        //Webcam.setSWFLocation('images/pdf_icon.jpg');
        Webcam.attach(this.cameraEle.nativeElement);
    }
    closeCamera(){
        Webcam.reset();
    }

    ngOnDestroy(): void {
        Webcam.reset();
    }

    

    

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/camera/camera.component.ts